import React from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'ui';

const Loading = ({ loading, children }) => {
  if (loading) {
    return (
      <div className="ta-c w-fill mt-16">
        <Spinner className="mr-16" />
        <span>{t('common.loading')}</span>
      </div>
    );
  }
  return children;
};

const mapStateToProps = state => ({
  loading: state.loading,
});

export default connect(mapStateToProps)(Loading);
